import * as React from 'react';
import { Img } from 'common--design-library';
import { TableRow } from '../../componentsDesktop';
import { TimeFormat, DateFormat, dateFormatter } from 'easit--localization';

export interface IOddListRowProps {
    categoryName: string;
    resultText: string;
    rate: number;
    tipNameShort: string;
    eventName: string;
    eventDate: Date | null;
    lineNumber: number;
    groupName?: string;
    resultIcon?: string;
}

export const OddListRow: React.FC<IOddListRowProps> = (props) => {
    return (<TableRow className={`betdetail-row`} verticalAlign={"center"}>
        { props.groupName &&
            <div className={"bet-group-name"}>
                {props.groupName}
            </div>
        }
        <div className={"bet-info flex-grow-1 text-left"}>
            <div className={"d-flex flex-column px-2"}>
                <div>
                    {props.categoryName}
                </div>
                <div><span className={"pr-2"}>{props.lineNumber}</span> {props.eventName}</div>
                {props.eventDate && <div>
                    {dateFormatter.formatDateTime(props.eventDate, DateFormat.DDMMYYYY, TimeFormat.HHMM)}
                </div>}
            </div>
        </div>
        <div className={"tip-name"}>
            {props.tipNameShort}
        </div>
        <div className={"rate-value"}>
            {props.rate}
        </div>
        <div className={"result-text"}>
            {props.resultText}
        </div>
        <div className={"result-img"}>
            <Img src={props.resultIcon ? props.resultIcon : "tip_none.gif"} />
        </div>
    </TableRow>
    );
};
